export { default } from './ColumnChartWidgetBars';
